if (!customElements.get('rm-product-controls')) {
  customElements.define('rm-product-controls', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const { signal } = this.abort;
      document.addEventListener('click', event => {
        const link = event.target.closest('[data-rm-open-description]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const description = document.getElementById(link.hash.slice(1));
        if (!description || !this.closest('.rm-pdp-hero')?.contains(description)) return;
        event.preventDefault();
        description.open = true;
        description.querySelector('summary').focus({ preventScroll: true });
        description.scrollIntoView({ block: 'start' });
      }, { signal });
      const slot = this.querySelector('.rm-pdp__action-slot');
      const actions = this.querySelector('.rm-pdp__actions');
      const stickyImage = this.querySelector('.rm-pdp__sticky-image');
      const optionInputs = [...this.querySelectorAll('.rm-pdp__pill-radio[data-variant-input]')];
      const stickyOptions = [...this.querySelectorAll('[data-rm-sticky-option]')];
      const syncStickyOptions = () => stickyOptions.forEach(button => {
        const input = optionInputs.find(candidate => candidate.dataset.index === button.dataset.index && candidate.value === button.dataset.value);
        const selected = Boolean(input?.checked);
        button.disabled = !input || input.disabled;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      this.sticky = new IntersectionObserver(([entry]) => {
        actions.classList.toggle('is-stuck', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      });
      this.sticky.observe(slot);

      this.addEventListener('click', event => {
        const button = event.target.closest('[data-rm-sticky-option]');
        if (!button) return;
        const input = optionInputs.find(candidate => candidate.dataset.index === button.dataset.index && candidate.value === button.dataset.value);
        if (!input || input.disabled) return;
        input.click();
        syncStickyOptions();
      }, { signal });
      document.addEventListener('variant:change', event => {
        const variant = event.detail?.variant;
        if (!variant || ![...this.querySelectorAll('[data-product-select] option')].some(option => Number(option.value) === variant.id)) return;
        syncStickyOptions();
        if (stickyImage && variant.featured_image?.src) {
          const source = new URL(variant.featured_image.src, window.location.origin);
          source.searchParams.set('width', '160');
          stickyImage.src = source.href;
          stickyImage.removeAttribute('srcset');
        }
      }, { signal });
      syncStickyOptions();

      const key = 'rockmama:wishlist:v1';
      const save = this.querySelector('[data-rm-save]');
      const status = this.querySelector('[data-rm-save-status]');
      const read = () => {
        try {
          const items = JSON.parse(localStorage.getItem(key) || '[]');
          return Array.isArray(items) ? items.filter(item => typeof item.handle === 'string' && typeof item.title === 'string' && /^\/products\/[a-z0-9-]+$/.test(item.url)).slice(0, 100) : [];
        } catch { return []; }
      };
      const render = () => {
        if (!save) return;
        const items = read();
        const saved = items.some(item => item.handle === this.dataset.productHandle);
        save.hidden = false;
        save.setAttribute('aria-pressed', String(saved));
        save.setAttribute('aria-label', saved ? 'Remove from wishlist on this device' : 'Save to wishlist on this device');
        this.querySelector('.rm-pdp__saved').hidden = !items.length;
        this.querySelector('[data-rm-save-count]').textContent = items.length;
        const list = this.querySelector('[data-rm-saved-list]');
        list.replaceChildren(...items.map(item => {
          const li = document.createElement('li');
          const link = document.createElement('a');
          link.href = item.url;
          link.textContent = item.title;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.rmRemove = item.handle;
          remove.textContent = 'Remove';
          remove.setAttribute('aria-label', `Remove ${item.title} from wishlist`);
          li.append(link, remove);
          return li;
        }));
      };
      const write = (items, message) => {
        try {
          localStorage.setItem(key, JSON.stringify(items));
          render();
          status.textContent = message;
        } catch { status.textContent = 'Your browser could not save this wishlist. Please enable browser storage and try again.'; }
      };
      this.addEventListener('click', event => {
        if (event.target.closest('[data-rm-save]')) {
          const items = read();
          const exists = items.some(item => item.handle === this.dataset.productHandle);
          const next = items.filter(item => item.handle !== this.dataset.productHandle);
          if (!exists) next.unshift({ handle: this.dataset.productHandle, title: this.dataset.productTitle, url: this.dataset.productUrl });
          write(next.slice(0, 100), exists ? 'Removed from wishlist.' : 'Saved on this device.');
        }
        const remove = event.target.closest('[data-rm-remove]');
        if (remove) {
          write(read().filter(item => item.handle !== remove.dataset.rmRemove), 'Removed from wishlist.');
          save.focus();
        }
      }, { signal });
      window.addEventListener('storage', event => { if (event.key === key) render(); }, { signal });
      render();

      // Code Black Belt injects its product rail after the section loads.
      const labelRails = () => this.querySelectorAll('.cbb-frequently-bought-products').forEach(rail => {
        rail.tabIndex = 0;
        rail.setAttribute('role', 'list');
        rail.setAttribute('aria-label', 'Frequently bought together products — scroll for more');
      });
      this.appObserver = new MutationObserver(labelRails);
      this.appObserver.observe(this, { childList: true, subtree: true });
      labelRails();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.sticky?.disconnect();
      this.appObserver?.disconnect();
    }
  });
}
